export const COLUMNS = {
    TITLE: 'title',
    TOPIC: 'topic',
    ADMIN_PROFILES: 'adminProfileIds',
    START_DATE: 'startDate',
    END_DATE: 'endDate',
};

export const HEADERS = {
    [COLUMNS.TITLE]: 'Notification Title',
    [COLUMNS.TOPIC]: 'Notification Topic',
    [COLUMNS.ADMIN_PROFILES]: 'Admin Roles',
    [COLUMNS.START_DATE]: 'Start Date',
    [COLUMNS.END_DATE]: 'End Date',
};

export const COLUMNS_DATA = [
    {
        columnId: COLUMNS.TITLE,
        fixed: true,
        defaultWidth: 320,
        minWidth: 260,
        maxWidth: 500,
    },
    {
        columnId: COLUMNS.TOPIC,
        fixed: false,
        defaultWidth: 320,
        minWidth: 260,
        maxWidth: 500,
    },
    {
        columnId: COLUMNS.ADMIN_PROFILES,
        fixed: false,
        defaultWidth: 500,
        minWidth: 250,
        maxWidth: 700,
    },
    {
        columnId: COLUMNS.START_DATE,
        fixed: false,
        defaultWidth: 150,
        minWidth: 120,
        maxWidth: 250,
    },
    {
        columnId: COLUMNS.END_DATE,
        fixed: false,
        defaultWidth: 150,
        minWidth: 120,
        maxWidth: 250,
    },
];

export const PLACE = 'Internal Notifications';
